import encodeSteps from './step_encoding';
import createStepDefinitions from './step_definitions';
import getStepOrder from './step_order';

export default ({ translate: t, application, location, companyContext }) => {
  const stepMap = createStepDefinitions({ translate: t, application, location, companyContext });
  const stepOrder = getStepOrder(companyContext);

  const steps = encodeSteps({ stepOrder, stepMap, application, location, t });
  return steps;
};
